import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  SALES_INVOICE: "api/GetAllPurchaseInvoice",
  SALES_INVOICE_BY_ID: "api/GetPurchaseInvoiceById",
  INVOICE_EXPORT: "api/ExportPurchaseInvoice",
}

const getSalesInvoice = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.SALES_INVOICE, {params: data});
  return res.data;
};

const getSalesInvoiceById = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.SALES_INVOICE_BY_ID}?id=${id}`);
  return res.data;
};

const getInvoiceExport = async (data: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.INVOICE_EXPORT, { params: data, responseType: "arraybuffer" });
  return res;
}

const SalesInvoice = {
  getSalesInvoice,
  getSalesInvoiceById,
  getInvoiceExport,
};

export default SalesInvoice;